import { MenuItemChildren, MenuItemRoot } from './SidebarMenus';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function SidebarItem({ icon, items, path, openSidebar, isSidebarOpen, name }) {
  const location = useLocation();
  const isExpandable = items && items.length > 0;
  const [isItemOpen, setIsItemOpen] = useState(false);

  useEffect(() => {
    if (isExpandable) {
      const shouldBeOpen = !!items?.find((item) => item.path === location.pathname);
      setIsItemOpen(shouldBeOpen);
    }
  }, [location.pathname, items, isExpandable]);

  const handleClick = () => {
    openSidebar();
    if (isExpandable) {
      setIsItemOpen((prev) => !prev);
    }
  };

  return (
    <>
      <MenuItemRoot
        path={path}
        handleClick={handleClick}
        icon={icon}
        isExpandable={isExpandable}
        isItemOpen={isItemOpen}
        name={name}
      />
      {isSidebarOpen && <MenuItemChildren isExpandable={isExpandable} isItemOpen={isItemOpen} items={items} />}
    </>
  );
}

export default SidebarItem;
